import { Helmet } from 'react-helmet-async';
import KeywordBased from 'src/sections/overview/dashboards/views/keywordBased';

export default function BrandShieldKoBiddingAuto() {
  return (
    <>
      <Helmet>
        <title>KO Bidding Auto</title>
      </Helmet>

      <KeywordBased />
    </>
  );
}
